import { c as _c } from "react/compiler-runtime";
import { NewPasswordCardPropertiesType } from "@website/widget/login/components/new-password-card/new-password-card.types";
import { ResetPasswordVerifyOtpService } from "@website/widget/login/services/reset-password-verify-otp";
import { useState } from "react";
export const useNewPasswordCard = properties => {
  const $ = _c(16);
  const {
    setStep,
    onEndAuth,
    userData
  } = properties;
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [password, setPassword] = useState("");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = value => {
      setPassword(value);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const onChangePassword = t0;
  let t1;
  if ($[1] !== password || $[2] !== setStep || $[3] !== userData) {
    t1 = async _event => {
      _event.preventDefault();
      if (password) {
        setIsLoading(true);
        setError("");
        const {
          otp,
          otpId
        } = userData;
        if (otp && otpId) {
          ResetPasswordVerifyOtpService({
            code: otp,
            newPassword: password,
            otpId
          }).then(() => {
            setStep("password-change-successful");
          }).catch(error_0 => {
            setError(error_0?.response?.data?.message || "\u062E\u0637\u0627\u06CC\u06CC \u0631\u062E \u062F\u0627\u062F\u0647\u060C \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F.");
          }).finally(() => setIsLoading(false));
        } else {
          setStep("phone-number");
        }
      } else {
        setError("\u0631\u0645\u0632 \u0639\u0628\u0648\u0631 \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F.");
      }
    };
    $[1] = password;
    $[2] = setStep;
    $[3] = userData;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const onSubmitPassword = t1;
  let t2;
  if ($[5] !== onEndAuth) {
    t2 = () => {
      onEndAuth?.();
    };
    $[5] = onEndAuth;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const onCloseClick = t2;
  let t3;
  if ($[7] !== setStep) {
    t3 = () => {
      setStep("otp");
    };
    $[7] = setStep;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const onBackClick = t3;
  let t4;
  if ($[9] !== error || $[10] !== isLoading || $[11] !== onBackClick || $[12] !== onCloseClick || $[13] !== onSubmitPassword || $[14] !== password) {
    t4 = {
      isLoading,
      password,
      onBackClick,
      onCloseClick,
      onChangePassword,
      onSubmitPassword,
      error
    };
    $[9] = error;
    $[10] = isLoading;
    $[11] = onBackClick;
    $[12] = onCloseClick;
    $[13] = onSubmitPassword;
    $[14] = password;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};